import { Container } from 'react-bootstrap';
import '../index.scss';

const Cases = () => {
  return (
    <div className="prmPage" data-testid="prm-cases-page">
      <Container>
        <h1 className="Heading Heading--h5">Cases</h1>
        <p className="Preamble">Cases will be available here soon.</p>
      </Container>
    </div>
  );
};

export default Cases;
